import { render } from "./AddWorkerToWarehouse.vue?vue&type=template&id=596a792e&scoped=true&ts=true"
import script from "./AddWorkerToWarehouse.vue?vue&type=script&lang=ts"
export * from "./AddWorkerToWarehouse.vue?vue&type=script&lang=ts"

import "./AddWorkerToWarehouse.vue?vue&type=style&index=0&id=596a792e&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596a792e"]])

export default __exports__